export const isGreaterThanOrEqualTo = (number) => (value, values) => {
  const valid = parseInt(value) >= number
  if (!valid) {
    return `Min ${number}`
  }
}

export const isLessThanOrEqualTo = (number) => (value, values) => {
  const valid = parseInt(value) <= number
  if (!valid) {
    return `Max ${number}`
  }
}

export const isInt = (value, values) => {
  const valid = /^(?:[-+]?(?:0|[1-9]\d*))$/.test(value)
  if (!valid) {
    return "Must be an integer"
  }
}

// Run validator only if shouldValidate returns truthy
export const validateIf =
  (shouldValidate, ...validators) =>
  (value, values) =>
    shouldValidate(value, values)
      ? validators.map((v) => v(value, values)).find((e) => e)
      : null

// Validate agaisnt another field with any validator
// Ex. validate.againstField("points", validate.isLessThanOrEqualTo)
export const againstField = (field, validator) => (value, values) => {
  try {
    // try running a returned function from the validator
    return validator(values[field])(value, values)
  } catch (e) {
    // catch if the validator does not return a function
    return validator(values[field], values)
  }
}

// Helper function for merging multiple validtors to produce
// one umbrella error message.
export const customErrorMessage = (...validators) => {
  const subValidators = validators.slice(0, -1)
  const errorMessage = validators.slice(-1)[0]
  // Check if last item in validators is a string.
  if (typeof errorMessage === "string") {
    // Use the custom errorMessage in place of any other error message
    // produced by the validator functions.
    return (...args) => subValidators.find((fn) => fn(...args)) && errorMessage
  }

  return validators
}

export const findErrorMessage =
  (...validators) =>
  (value, values) =>
    validators.reduce(
      (errorMessage, validator) => errorMessage || validator(value, values),
      null
    )
